import {
  CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY,
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
  CONTENT_REFERENCE_TYPE_SERIES,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS,
  CONTENT_REFERENCE_TYPE_PRODUCT,
  CONTENT_REFERENCE_TYPE_COURSE_MODULE_PRACTICE,
  CONTENT_REFERENCE_TYPE_COURSE_MODULE_OTHER,
  CONTENT_REFERENCE_TYPE_PRIMARY_COURSE,
} from 'services/content-references/types'

/**
 * List of reference types that should be populated from metadata
 * These are used when grabbing metadata from series or other content
 */
export const REFERENCE_TYPE_KEYS_TO_POPULATE_FROM_METADATA = [
  CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY,
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
]

/**
 * List of reference types that should be single-select only
 * These fields will not allow multiple selections
 */
export const SINGLE_SELECT_REFERENCE_TYPES = [
  CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_SERIES,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_PRIMARY_COURSE,
]

/**
 * List of reference types that should be multi-select
 * These fields will allow multiple selections
 */
export const MULTI_SELECT_REFERENCE_TYPES = [
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
  CONTENT_REFERENCE_TYPE_PRODUCT,
  CONTENT_REFERENCE_TYPE_COURSE_MODULE_PRACTICE,
  CONTENT_REFERENCE_TYPE_COURSE_MODULE_OTHER,
]

/**
 * List of fields that should be treated as boolean values
 * These fields will be converted to boolean when saving
 */
export const BOOLEAN_FIELDS = [
  'contentSearchNoIndex',
  'excludeFromRecommendations',
  'generatePath',
  'published',
  'seoRobotsNoFollow',
  'seoRobotsNoIndex',
]

/**
 * List of fields that should be treated as numbers
 * These fields will be converted to numbers when saving
 */
export const NUMBER_FIELDS = ['seasonNumber', 'episodeNumber']

/**
 * List of fields that should be treated as textareas
 * These fields will have special handling for empty values
 */
export const TEXTAREA_FIELDS = ['shortDescription', 'description', 'thirdPartyDescription']
